import { render, staticRenderFns } from "./MobilePayments.vue?vue&type=template&id=21936510"
import script from "./MobilePayments.vue?vue&type=script&lang=js"
export * from "./MobilePayments.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports